export default function Contact() {
  return (
    <section id="contact" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-8 sm:mb-12">
            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <div className="w-8 sm:w-12 h-0.5 bg-[#C9A961]"></div>
              <p className="text-[#C9A961] text-xs sm:text-sm tracking-[0.2em] uppercase font-light">
                Get in Touch
              </p>
              <div className="w-8 sm:w-12 h-0.5 bg-[#C9A961]"></div>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight mb-4 sm:mb-6 px-4">
              Ready to Elevate
              <br />
              <span className="text-[#C9A961] italic">Your Next Event</span>
              <br />
              with Exceptional Cuisine?
            </h2>
            <p className="text-gray-300 text-sm sm:text-base md:text-lg font-light leading-relaxed px-4">
              Let's discuss your vision and create a memorable culinary experience together. Contact us directly through the information below.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 hover:bg-white/10 transition-all">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center rounded-full bg-[#C9A961]/20 text-[#C9A961] mx-auto mb-3 sm:mb-4">
                <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2 text-base sm:text-lg">WhatsApp</h3>
              <a 
                href="https://wa.me/447843585337"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 text-sm sm:text-base font-light hover:text-[#C9A961] transition-colors cursor-pointer"
              >
                07843 585337
              </a>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 hover:bg-white/10 transition-all">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center rounded-full bg-[#C9A961]/20 text-[#C9A961] mx-auto mb-3 sm:mb-4">
                <i className="ri-mail-line text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2 text-base sm:text-lg">Email</h3>
              <a 
                href="mailto:yallaziad@gmail.com"
                className="text-gray-300 text-sm sm:text-base font-light hover:text-[#C9A961] transition-colors cursor-pointer break-all"
              >
                yallaziad@gmail.com
              </a>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 hover:bg-white/10 transition-all">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center rounded-full bg-[#C9A961]/20 text-[#C9A961] mx-auto mb-3 sm:mb-4">
                <i className="ri-time-line text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2 text-base sm:text-lg">Availability</h3>
              <p className="text-gray-300 text-sm sm:text-base font-light">
                Monday - Sunday
                <br />
                By Appointment Only
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
